import fp from 'lodash/fp';
import React, { FC } from 'react';

import { animation, GridColumn, GridRow, TransitionComponent } from 'Modules/ui2';

import { Proffits } from './Proffits';
import { Prices, PriceCardKeys, Price, PriceCard } from './Prices';
import { Tariff, TariffsProps } from './types';
import styles from './index.module.scss';


type MapData = (data: TariffsProps['data']) => (Pick<Tariff, 'button' | 'onlySelected'> & Price)[];
const mapData: MapData = fp.pipe(
    fp.toPairs,
    fp.map<[PriceCardKeys, Tariff], ReturnType<MapData>[0]>(
        ([key, { proffits, ...value }]) => ({
            priceKey: key,
            ...value,
        }),
    ),
);

export const Tariffs: FC<TariffsProps> = ({ data, select, selected }) => (
    <GridRow>
        <Prices
            data={mapData(data)}
            selected={selected}
            onSelect={select}
        />
        <Proffits selected={data[selected].proffits} />
    </GridRow>
);

export const MobileTariffs: FC<TariffsProps> = ({ data, select, selected, buttonProps }) => (
    <div className={styles.container}>
        {mapData(data).map(({ priceKey, priceTextSize, button: Button, onlySelected }) => (
            <GridRow key={priceKey}>
                <GridColumn size={6}>
                    <PriceCard
                        priceKey={priceKey}
                        priceTextSize={priceTextSize}
                        onSelect={select}
                        selected={priceKey === selected}
                        mobile
                    />
                </GridColumn>
                <TransitionComponent in={priceKey === selected} timeout={animation * 0.5}>
                    <GridColumn size={6} className={styles.mobileProffit}>
                        <Proffits
                            selected={data[priceKey].proffits}
                            onlySelected={onlySelected}
                        />
                        <Button {...buttonProps} />
                    </GridColumn>
                </TransitionComponent>
            </GridRow>
        ))}
    </div>
);

export * from './Prices';
export * from './types';
